<template>
	<divBox class="elBox" :title="'城市预警排名'">
		<!-- :autoplay="true" :loop="true" -->
		<el-carousel
			class="el-carousel"
			direction="vertical"
			:interval="30000"
			indicator-position="none">
			<el-carousel-item v-for="(item, index) in warningRanking" :key="'warningRanking' + index" class="elBoxItem">
				<div
					v-for="(nI, i) in item"
					:key="'niten' + i"
					class="flex align-center justify-start margintbsm">
					<div class="flex justify-center align-center text-cyan text-lg margin-right-sm rankIndex">
						{{ nI.index }}
					</div>
					<div class="flex flex-direction" style="width:80%">
						<div class="flex align-center margin-bottom-xs">
							<div
								class="padding-r-sm flex align-center justify-center text-xsss margin-right-sm realTimeCity">
								{{ nI.cityName }}
							</div>
							<div class="rankText">
								<span class="text-xsss margin-right-xs">预警事件数</span>{{nI.alarmNum}}
							</div>
						</div>
						<el-progress :percentage="percentage(nI.alarmNum)" :show-text="false"></el-progress>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>
	</divBox>
</template>

<script>
import divBox from '../../components/divBox.vue'
import { dataInterface } from '@/api/dataInterfaceApi';
import { Progress, Carousel, CarouselItem } from 'element-ui'
export default {
	data() {
		return {
			secTitle: {
				title: '城市预警排名'
			},
			warningRanking: [], // list
		};
	},
	components: {
		divBox,
		ElProgress: Progress,
		ElCarousel: Carousel,
		ElCarouselItem: CarouselItem
	},
	props: {},
    inject: ['cityUpdate'],
    computed: {
        computedProperty() {
        	return this.cityUpdate()
        }
    },
    watch: {
        computedProperty(val) {
			this.getData(val)
        },
    },
	mounted() {},
	methods: {
		getData(data) {
			this.selectCityEarlyWarningRanking(data);
		},
		percentage(i) {
			return parseFloat(i, 10) / 100 || 0
		},
		selectCityEarlyWarningRanking(data = {}) {
			let _this = this;
			let params = {};
			if (data) {
				params = {
					"enCode": "TiDB-shengshiqu-chengshiyujingpaiming",
					"@province": data.province || data.city || data.district
				}
			} else {
				params = {
					"enCode": "TiDB-quanguo-chengshiyujingpaiming" //TiDB-全国-城市预警排名
				}
			}

			_this.warningRanking = []
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res || !res.length) return;
					let narr = []
					res.map((item, i) => {
						item.index = i + 1
						narr.push(item)
						if(narr.length === 3) {
							_this.warningRanking.push(narr)
							narr = []
						}
					})
					// _this.warningRanking = res;
				})
				.catch((err) => {
					console.log(err);
				});
		},
	}
}
</script>
<style lang="scss" scoped>
.elBox {
	height: 300px;
	::v-deep .el-progress-bar__outer {
		background: none !important;
	}
	.el-carousel {
		height: 100%;
		.elBoxItem {
			height: 3000px;
			font-size: 12px;
			.margintbsm {
				margin-top: 15px;
				margin-bottom: 15px;
				.rankIndex {
					border: 1px solid #129BFF;
					width: 50px;
					height: 50px;
				}
			}
		}
	}
}
</style>